/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LocationCount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import LocationPopover from './LocationPopover/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2CrossLocation from 'DesignSystem/Svgs/Tysiav2CrossLocation/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LocationCount({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/LocationCount"
  
}) {
let connectionValueData = fromData.useDataFormat({ viewPath,
context: 'connection',
format: fromHelpers.getLocationCount,
})
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="LocationCount.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2CrossLocation
  viewPath={`${viewPath}/Tysiav2CrossLocation`}
 marginTop={4}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtTypographyFontsizeM}
 color={dtColorsNeutral500}
 textDecoration="underline dashed"
 className="text-decoration-skip-ink-none text-underline-offset-4"
 data="connection"
 format="./helpers.js getLocationCount"
 text={connectionValueData}
 className="text-decoration-skip-ink-none text-underline-offset-4"
/>
</div>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<LocationPopover
{...childProps}
  viewPath={`${viewPath}/LocationPopover`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}